export default __webpack_public_path__ + "media/images/star-a9f1953a9b90645430425d0c6968347e.svg";